import React, { useEffect, useState } from "react";
import QRCode from "react-qr-code";
import { Container, Title, CopyButton, PixKey, QRCodeWrapper, DonationText } from "./DonationFloating.style";

const DonationFloating = ({ pixKey, currency, mbwayNumber, mbwayDisplay }) => {
    const isEuro = currency === "€";
    const [copyLabel, setCopyLabel] = useState(isEuro ? "Copiar MB WAY" : "Copiar PIX");

    useEffect(() => {
        setCopyLabel(isEuro ? "Copiar MB WAY" : "Copiar PIX");
    }, [isEuro]);

    const handleCopyPix = async () => {
        try {
            const supportKey = isEuro ? mbwayNumber : pixKey;
            await navigator.clipboard.writeText(supportKey);
            setCopyLabel(isEuro ? "MB WAY copiado!" : "PIX copiado!");
            setTimeout(
                () => setCopyLabel(isEuro ? "Copiar MB WAY" : "Copiar PIX"),
                2000
            );
        } catch (error) {
            setCopyLabel("Erro ao copiar");
            setTimeout(
                () => setCopyLabel(isEuro ? "Copiar MB WAY" : "Copiar PIX"),
                2000
            );
        }
    };

    return (
        <Container>
            <Title>Apoie o projeto ❤️</Title>

            <DonationText>
                Qualquer valor ajuda muito o projeto a se manter gratuito.
            </DonationText>

            {!isEuro && (
                <QRCodeWrapper>
                    <QRCode value={pixKey} size={128} level="L" />
                </QRCodeWrapper>
            )}

            {isEuro && (
                <QRCodeWrapper>
                    <img
                        src={require("../../Assets/images/MB_WAY.jpg")}
                        alt="MB WAY"
                        style={{ width: "100%", height: "auto", borderRadius: "6px" }}
                    />
                </QRCodeWrapper>
            )}

            {isEuro && <PixKey>MB WAY: {mbwayDisplay || mbwayNumber}</PixKey>}

            <CopyButton onClick={handleCopyPix}>
                {copyLabel}
            </CopyButton>
        </Container>
    );
};

export default DonationFloating;
